import * as React from "react"
import { cleanMultipleHttps } from "../../../../cms/blocks/utils.gen"
import { parseImageUrl } from "../../../../drupal/rendering/image_utils.mod"
import { ParsedMediaImage } from "../../../../drupal/types_and_parser/types"

export type UpdatesBlockProps = {
  title?: string;
  items: UpdateItemProps[];
  isStyleguide?: boolean;
}

export type UpdateItemProps = {
  category?: string;
  title?: string;
  link?: string;
  field_image?: ParsedMediaImage;

  imageStyleguide?: {
    src: string;
    srcSet: string;
    alt: string;
  }
}

export const UpdatesBlock = (props: UpdatesBlockProps) => {
  const {
    title,
    items,
    isStyleguide,
  } = props;

  return (
    <section className="updates">
      <div className="updates__inner">
        <div className="container container--m grid--block">
          {title &&
            <h2 className="updates__title">{title}</h2>
          }
          <ul className={`updates__list updates__list--${items.length}-items`}>
            {items.map((item, index) => {
              const {
                title,
                category,
                link,
                field_image,
                imageStyleguide,
              } = item;
              const image = isStyleguide ? imageStyleguide : field_image;
              return (
                <li
                  key={`update-${index}`}
                  className={`updates__item updates__item--${image ? 'has-image' : 'text-only'}`}
                >
                  <a href={cleanMultipleHttps(link)} className="updates__link">
                    {isStyleguide && imageStyleguide &&
                      <div className="updates__visual">
                        <img
                          src="/images/empty.png"
                          data-src={imageStyleguide.src}
                          data-srcSet={imageStyleguide.srcSet}
                          alt={imageStyleguide.alt}
                          width="680"
                          height="680"
                          sizes="auto"
                          className="updates__image lazyload"
                        />
                      </div>
                    }
                    {!isStyleguide && field_image &&
                      <div className="updates__visual">
                        <img className="updates__image lazyload"
                          src="/images/empty.png"
                          data-src={`${field_image?.field_media_image?.image?.style_urls['450x450']}`}
                          data-srcset={`${parseImageUrl(
                            field_image?.field_media_image?.image?.style_urls['450x450']
                          )} 450x450, ${parseImageUrl(
                            field_image?.field_media_image?.image?.style_urls['600x600']
                          )} 600x600, ${parseImageUrl(
                            field_image?.field_media_image?.image?.style_urls['1200x1200']
                          )}`}
                          alt={field_image?.field_media_image?.alt}
                          sizes="auto"
                          width="680"
                          height="680"
                        />
                      </div>
                    }
                    <div className="updates__message">
                      <span className="updates__label">{category}</span>
                      <h3 className="updates__item-title">
                        {title}
                        <span className="updates__icon" aria-hidden="true" />
                      </h3>
                    </div>
                  </a>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    </section >
  )
}
